import Login from "pages/corporate/Login";
import React from "react";
import { Route, Routes } from "react-router";

function CorporateRoutesProvider() {
  return (
    <Routes>
      <Route index element={<Login />} />
      <Route path="/login" element={<Login />} />
    </Routes>
  );
}

export default CorporateRoutesProvider;
